<template>

      <div>
        <span class="sec-description">{{ $t('diagnostic.dafo.title') }}</span>
          <table class="dafo-table" v-if="dafoItems!=undefined" cellspacing="10px" cellpadding="5">
            <tr>
              <th><span class="weaknesses">{{ $t('diagnostic.dafo.weaknesses') }}</span></th><th @click="popup(2)" class="sample"><span class="examples"></span></th>
              <th><span class="threats">{{ $t('diagnostic.dafo.threats') }}</span></th><th @click="popup(4)" class="sample"><span class="examples"></span></th>
            </tr>
            <tr>
              <td colspan="2" class="description">
                <span>{{ $t('diagnostic.dafo.description.weaknesses') }}</span>
              </td>
              <td colspan="2" class="description">
                <span>{{ $t('diagnostic.dafo.description.threats') }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <v-container class="select-editable">
                  <v-textarea auto-grow height=auto class="text" v-for="(input,k) in dafoItems.weaknesses"
                      v-model="dafoItems.weaknesses[k].input" rows="1" hide-details color=black row-height=35px @change="changeOption()" @input="changeOption()" spellcheck="false">
                    <template v-slot:append class="no-print">
                      <v-icon class="no-print" style="padding: 10px; cursor: pointer;" @click="deleteDafo('weaknesses',k);">delete</v-icon>
                    </template>  
                  </v-textarea>
                </v-container>
                <div class="more">
                  <span class="add no-print" @click="add('weaknesses')">+</span>
                </div>
              </td>
              <td colspan="2">
                  <v-container class="select-editable">
                    <v-textarea auto-grow height=auto class="text" v-for="(input,k) in dafoItems.threats"
                      v-model="dafoItems.threats[k].input" rows="1" hide-details color=black row-height=35px @change="changeOption()" @input="changeOption()" spellcheck="false">
                      <template v-slot:append class="no-print">
                        <v-icon class="no-print" style="padding: 10px; cursor: pointer;" @click="deleteDafo('threats',k);">delete</v-icon>
                      </template>
                    </v-textarea>
                  </v-container>
                  <div class="more">
                    <span class="add no-print" @click="add('threats')">+</span>
                  </div>
              </td>
            </tr>
            <tr>
              <th><span class="strenghts">{{ $t('diagnostic.dafo.strenghts') }}</span></th><th @click="popup(1)" class="sample"><span class="examples"></span></th>
              <th><span class="opportunities">{{ $t('diagnostic.dafo.opportunities') }}</span></th><th @click="popup(3)" class="sample"><span class="examples"></span></th>
            </tr>
            <tr>
              <td colspan="2" class="description">
                <span>{{ $t('diagnostic.dafo.description.strenghts') }}</span>
              </td>
              <td  colspan="2" class="description">
                <span>{{ $t('diagnostic.dafo.description.opportunities') }}</span>
              </td>
            </tr>
              <td colspan="2">
                  <v-container class="select-editable">
                    <v-textarea auto-grow height=auto class="text" v-for="(input,k) in dafoItems.strenghts"
                      v-model="dafoItems.strenghts[k].input" rows="1" hide-details color=black row-height=35px @change="changeOption()" @input="changeOption()" spellcheck="false">
                      <template v-slot:append class="no-print">
                        <v-icon class="no-print" style="padding: 10px; cursor: pointer;" @click="deleteDafo('strenghts',k);">delete</v-icon>
                      </template>
                    </v-textarea>
                  </v-container>
                <div class="more">
                  <span class="add no-print" @click="add('strenghts')">+</span>                  
                </div>
              </td>
              <td colspan="2">
                  <v-container class="select-editable">
                    <v-textarea auto-grow height=auto class="text" v-for="(input,k) in dafoItems.opportunities"
                      v-model="dafoItems.opportunities[k].input" rows="1" hide-details color=black row-height=35px @change="changeOption()" @input="changeOption()" spellcheck="false"> 
                       <template v-slot:append class="no-print">
                          <v-icon class="no-print" style="padding: 10px; cursor: pointer;" @click="deleteDafo('opportunities',k);">delete</v-icon>
                        </template> 
                    </v-textarea>
                  </v-container>
                  <div class="more">
                    <span class="add no-print" @click="add('opportunities')">+</span>
                  </div>
              </td>
            <tr>
            </tr>
          </table>

        <div :class="{'hidden': !change}" @click="save()" class="save no-print">
          {{ $t('general.save_changes') }}
        </div>


        <div :class="{'show': popupShow}" class="overlay" @click.self="popupShow = false">
          <div class="popup">
            <span class="title">{{ $t('diagnostic.dafo.examples') }}</span>
          <div v-for="item in dafoExamples" @click="selectOptionDafo(item)" class="examples">{{item.data}}</div> 
          </div>
        </div>  
      </div>

</template>

<script>

export default {
  name: 'DAFO',
  data () {
    return {
      change: false,

      popupShow: false,

      dafoExamples: "",
      dafoType: "",
      dafoItems: {}, 

    }
  },
  computed: {
    selectedLocation (){
      return this.$store.getters['locations/getSelectedLocation'];
    },

    dafoOptions() {
      return this.$store.getters['locations/getDafoOptions'];
    },

    dafoStrenghtsData() {
      var result = [];
      for (var item in this.dafoOptions){
        if ( this.dafoOptions[item].type=="1" && this.dafoOptions[item].status=="0" ) {
          var element = {};
          element.id=this.dafoOptions[item].id;
          element.data = this.dafoOptions[item].data;
          result.push(element);
        }
      }
      return result;
    },

    dafoStrenghtsOptions() {
      var result = [];
      for (var item in this.dafoOptions){
        if ( this.dafoOptions[item].type=="1" && this.dafoOptions[item].status=="0" ) {
          var element = {};
          element.id=this.dafoOptions[item].id;
          element.data = this.dafoOptions[item].data;
          result.push(element);
        } 
      }
      return result;
    },

    dafoWeaknessesOptions() {
      var result = [];
      for (var item in this.dafoOptions){
        if ( this.dafoOptions[item].type=="2" && this.dafoOptions[item].status=="0" ) {
          var element = {};          
          element.id=this.dafoOptions[item].id;
          element.data = this.dafoOptions[item].data;
          result.push(element);
        }
      }
      return result;
    },

    dafoOpportunitiesOptions() {
      var result = [];
      for (var item in this.dafoOptions){
        if ( this.dafoOptions[item].type=="3" && this.dafoOptions[item].status=="0" ) {
          var element = {};          
          element.id=this.dafoOptions[item].id;
          element.data = this.dafoOptions[item].data;
          result.push(element);
        }
      }
      return result;
    },

    dafoThreatsOptions() {
      var result = [];
      for (var item in this.dafoOptions){
        if ( this.dafoOptions[item].type=="4" && this.dafoOptions[item].status=="0" ) {
          var element = {};
          element.id=this.dafoOptions[item].id;
          element.data = this.dafoOptions[item].data;
          result.push(element);
        }
      }
      return result;
    },

    dafoData() {
      var data = this.$store.getters['locations/getDafoData'];
      if (data== null || data.length==0 ){
        var result = { 
          strenghts : [
          ],
          weaknesses : [
          ],
          opportunities : [
          ],
          threats : [
          ]
        };
      }
      else {
        data = data.replace(/(\r\n|\n|\r)/gm,"\\n");
        var result = JSON.parse(data);
      }
      return this.dafoItems = result;
    },

  },
  methods: {
    popup(type) {
      switch (type){
        case 1:
          this.dafoExamples = this.dafoStrenghtsOptions;
          this.popupShow = true;
          break;
        case 2:
          this.dafoExamples = this.dafoWeaknessesOptions;
          this.popupShow = true;
          break;
        case 3:
          this.dafoExamples = this.dafoOpportunitiesOptions;
          this.popupShow = true;
          break;
        case 4:
          this.dafoExamples = this.dafoThreatsOptions;
          this.popupShow = true;
          break;
      }
      this.dafoType = type;
    },

    selectOptionDafo(item) {
      switch (this.dafoType){
        case 1:
          this.dafoData.strenghts.push({ input: item.data });
          break;
        case 2:
          this.dafoData.weaknesses.push({ input: item.data });
          break;
        case 3:
          this.dafoData.opportunities.push({ input: item.data });
          break;
        case 4:
          this.dafoData.threats.push({ input: item.data });
          break;
        }
      this.change = true;
      this.dafoType = undefined;
      this.popupShow = false;
      this.data = this.dafoData;
    },

    save() {
      var aData = {};
      var dafoAnswers = {
        strenghts: this.dafoData.strenghts,
        weaknesses: this.dafoData.weaknesses,
        opportunities: this.dafoData. opportunities,
        threats: this.dafoData.threats
      };
      aData.dafo = JSON.stringify(dafoAnswers);
      aData.restaurant_id = this.$store.getters['locations/getSelectedLocation'].id;
      var self = this;
      this.$store.dispatch( 'locations/updateDafo', aData ).then(function(){
        self.change = false;
      });      
    },

    changeOption() {
      this.change = true;
    },

    add(type) {
      this.dafoItems[type].push({ input: '' });
      this.change = true;
    },

    deleteDafo(section, key){
      this.$delete(this.dafoItems[section], key);
      this.dafoItems = {...this.dafoItems};
      this.change = true;
    },

    selectOption(e) {
      e.target.nextElementSibling.value = e.target.value;
      e.target.value = "";
    },

    checkChangesBeforeExit: function() {
        if (this.change) {
          return false;
        } else return true;
    },

    loadComponentData () {
      var self = this;
      this.$store.dispatch('locations/loadDafoOptions', this.$store.getters['locations/getSelectedLocation'].id );
      this.$store.dispatch('locations/loadDafoData', this.$store.getters['locations/getSelectedLocation'].id ).then(function(){
        self.dafoData;
      })
    },
  },
  watch: {
    selectedLocation () {
      if (this.selectedLocation==undefined){
        this.$store.getters['locations/getSelectedLocation'];
      }
      this.loadComponentData();
     },
  },
  created() {
    this.loadComponentData();
  },
   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  
  .sec-description {
    display: block;
    color: #999;
    margin-bottom: 40px;
  }

  .dafo-table {
    margin: 0 auto;
    border-color: white;
    max-width: 90%;
    width: 90%;

    th {
      height: 50px;
      background-color: var(--main_color);
      position: relative;
      width: 50%;

      &.sample {
        width: 50px;
        display: inline-block;
        overflow: auto;
        cursor: pointer;

        .examples {
          background-size: 27px;
          position: absolute;
          margin-top: 10px;
          margin-left: 50px;
          background-image: url('/img/diagnostic/examples.svg');
          width: 27px;
          height: 27px;
          padding: 0px;
          right: 10px;
        }
      }

      span {
        padding: 0px 6px 3px 35px;
        font-weight: bold;
        font-size: 18px;
        background-size: 20px;
        background-position: left center;
        height: 30px;
        text-transform: uppercase;
        font-size: 16px;
        color: #fff;

        &.strenghts {
          background-image: url('/img/diagnostic/strenghts.svg');
        }

        &.weaknesses {
          background-image: url('/img/diagnostic/weaknesses.svg');
        }

        &.opportunities {
          background-image: url('/img/diagnostic/opportunities.svg');
        }

        &.threats {
          background-image: url('/img/diagnostic/threats.svg');
        }

        
      }
    }

    td {
      overflow: hidden;
      vertical-align: top;

      &.description {
        width: 50%;
        background-color: #eee;
        padding: 5px;
        color: #777;
        font-size: 14px;
      }

      .select-editable {
           width: 100%;
           padding: 0px;
       }

      .text{
        background-color: white;
        margin: 0px;
        border-bottom: 1px solid #ddd;


      }

      .more {
        display: block;
        width: 100%;
        height: 50px;
        text-align: center;
        font-size: 15px;
        padding-top: 10px;

        .add, .remove {
          display: inline-block;
          margin: 0px 10px;
          border-radius: 100%;
          padding: 0px;
          line-height: 0.5;
          font-size: 27px;
          cursor: pointer;
          color: #fff;
          width: 25px;
          height: 25px;
          line-height: 25px;
          text-align: center;
        }

        .add {
          background-color: #8bc34a;
        }
        .remove {
          background-color: #d42525;
        }
      }
    }
  }

  .legend {
    margin-top: 40px;
    text-align: left;
    background-color: #eee;
    padding: 30px;

    .title {
      font-size: 16px !important;
    }

    .subtitle {
      display: inline;
      margin-left: 0px;
      font-size: 14px;
      color: #333;
    }

    .text {
      margin-left: 0px;
      font-size: 13px;
    }
  }

  .save {
    background-color: #8bc34a;
    width: fit-content;
    margin: 0 auto;
    margin-top: -40px;
    color: white;
    padding: 8px 25px;
    border-radius: 3px;
    font-size: 16px;
    cursor: pointer;
    opacity: 1;
    transition: 0.5s;
    text-transform: uppercase;

    &.hidden {
      display: none;
      opacity: 0;
      height: 0px;
      transition: 0.5s;
    }

  }

  .overlay {
    display: none;
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    transition: opacity 500ms;
    visibility: hidden;
    opacity: 0;

    &.show {
      display: unset;
      visibility: visible;
      opacity: 1;
    }

    .popup {
      visibility: visible;
      position: fixed;
      z-index: 50;
      background-color: white;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 59%;
      height: 73%;
      padding: 20px 10px;
      border-radius: 5px;
      overflow: auto;
      box-sizing: border-box;
  
      .examples {
        border-radius: 10px;
        background-color: #ddd;
        padding: 10px 20px;
        width: fit-content;
        margin: 10px auto;
        font-size: 15px;
        cursor: pointer;

      &:hover {
          background-color: var(--main_color);
        }
      }
    }
  }

</style>

<style lang="scss">

  .dafo-table {
    .v-text-field__slot {
        padding: 10px !important;
      }
  }

</style>